import React from 'react';
import { render } from 'react-dom';
import './sass/main.css';
import PS from './PS';

render(<PS />, document.getElementById('root'));